/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AnnouncementsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABQUlEQVR4nO2VvUrEQBCAV0HERrD0EcRC0FasVy/zkyKZyV0lJ3kBO5s0Clr6ADa+iCAoPoZo5w8WIpxnoWxOjxDikUsugnADWywz+33s7MIYMw1jDHN7A1hugKQPpO/IejSxxrT8cA1In5H1M7N69cGt9hKQ7gPLSw6erkpQa+08UQTIeo6sb0XgsQVJksx6HG0CySmyPI6CjiUA0FVkOQHWu7LQkQKiaAdI7t2DpQKSfhXwrwIHzybrwLFIkE9OBebPWwRNP7LHsj34pvLUiCAfw2KS20YFxpgZxHALSM4mLei5Qms7i+ke1Xd7IH0F1gtk/aglANbL7xZdI2sy/AQY7rq873eWgeSgYBaUE7hBgqQP2UPAehXH8Vy2jllWKg8c1x6iaA9Zj4GkGwTBQlGd54fr7qY/IxNID0sJ/kV8AVDMKVo7zupqAAAAAElFTkSuQmCC)
 */
export const AnnouncementsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19.56 2a3 3 0 0 0-2.46 1.28 3.85 3.85 0 0 1-1.86 1.42l-8.9 3.18a.5.5 0 0 0-.34.47v10.09a3 3 0 0 0 2.27 2.9l.62.16c1.57.4 3.15-.56 3.55-2.12a.92.92 0 0 1 1.23-.63l2.36.94c.42.27.79.62 1.07 1.03A3 3 0 0 0 19.56 22h.94c.83 0 1.5-.67 1.5-1.5v-17c0-.83-.67-1.5-1.5-1.5h-.94Zm-8.53 15.8L8 16.7v1.73a1 1 0 0 0 .76.97l.62.15c.5.13 1-.17 1.12-.67.1-.41.29-.78.53-1.1Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 10c0-1.1.9-2 2-2h.5c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5H4a2 2 0 0 1-2-2v-4Z"
        className={colorClass}
      />
    </svg>
  );
};
